import {toBoolean} from "./ValueUtils";
import {DEFAULT_LANG, DEFAULT_LOCALE} from "./localization/Messages";

function asString(el: HTMLElement, key: string): string {
    return el?.dataset && key in el.dataset ? String(el.dataset[key]) : undefined
}

function asBoolean(el: HTMLElement, key: string, defaultValue: boolean): boolean {
    return el?.dataset && key in el.dataset ? toBoolean(el.dataset[key], defaultValue) : defaultValue
}

//
// Note that I am trying to avoid jQuery in this module as it could be used by any number of
// bits of code, and as we move towards Vue.js, we will be trying to move away from jQuery.
//
export class PageHelper {
    readonly htmlEl: HTMLElement;
    readonly bodyEl: HTMLElement;
    readonly pageHeaderEl: HTMLElement;
    readonly locale: string;
    readonly lang: string;

    constructor() {
        if (typeof document !== 'undefined') {
            this.htmlEl = document.documentElement;
            this.bodyEl = document.body;
            this.pageHeaderEl = document.getElementById("page-header-container");
        } else {
            this.htmlEl = undefined;
            this.bodyEl = undefined;
            this.pageHeaderEl = undefined;
        }

        // Ensure we have some fall-backs for these values, even though they should
        // normally come from the HTML element, but it's possible not every page has
        // them set.

        this.locale =
            asString(this.htmlEl, 'locale') ||
            asString(this.pageHeaderEl, 'locale') ||
            asString(this.bodyEl, 'locale') ||
            DEFAULT_LOCALE;

        this.lang =
            this.htmlEl?.getAttribute('lang') ||
            asString(this.pageHeaderEl, 'language') ||
            asString(this.bodyEl, 'language') ||
            DEFAULT_LANG;
    }

    getHeaderString(key: string): string {
        return asString(this.pageHeaderEl, key);
    }

    getHeaderBoolean(key: string, defaultValue: boolean) {
        return asBoolean(this.pageHeaderEl, key, defaultValue);
    }
}
